import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import store from "@/store";
import { isDesktop } from '@/utils/isDesktop';
let Navigation = class Navigation extends Vue {
    authorized;
    open;
    isOpen = false;
    created() {
        this.isOpen = this.open;
    }
    items = [
        {
            icon: 'mdi-view-dashboard',
            text: 'Dashboard',
            link: { name: 'Dashboard' },
            show: 0,
        },
        {
            icon: 'mdi-calendar',
            text: 'Rozpis',
            link: { name: 'InstructorsTimeSchedule' },
            show: 0,
        },
        {
            icon: 'mdi-cash-multiple',
            text: 'Transakce',
            link: { name: 'Transactions' },
            show: 100,
        },
        {
            icon: 'mdi-receipt',
            text: 'Doklady',
            link: { name: 'Receipts' },
            show: 50,
        },
        {
            icon: 'mdi-tag-multiple',
            text: 'Poukazy',
            link: { name: 'Vouchers' },
            show: 100,
        },
        {
            icon: 'mdi-chevron-up',
            iconAlt: 'mdi-chevron-down',
            text: 'Ostatní',
            model: false,
            children: [
                { text: 'Instruktoři', link: { name: 'Instructors' }, show: 50 },
                { text: 'Provozní doby', link: { name: 'OperatingHours' }, show: 100 },
                { text: 'Platové třídy', link: { name: 'Grades' }, show: 100 },
                { text: 'Smlouvy', link: { name: 'Contracts' }, show: 100 },
                { text: 'Ceny', link: { name: 'Pricing' }, show: 100 },
                { text: 'Analytika', link: { name: 'Analytics' }, show: 100 },
                { icon: '', text: 'Záloha dat', link: { name: 'AdminBackup' }, show: 100 },
                { icon: '', text: 'Historie změn', link: { name: 'ActivityLog' }, show: 100 },
                { icon: '', text: 'Nastavení školy', link: { name: 'SchoolSettings' }, show: 100 },
            ],
            show: 50,
        },
    ];
    get isDesktop() {
        return isDesktop();
    }
    get availableItems() {
        return this.items.filter(item => {
            let show = true;
            if (item.show >= 100) {
                show = this.isAdmin;
            }
            else if (item.show >= 50) {
                show = this.isModerator;
            }
            if (show) {
                if ('children' in item) {
                    Vue.set(item, 'availableChildren', item.children.filter(child => {
                        let show = true;
                        if (child.show >= 100) {
                            show = this.isAdmin;
                        }
                        else if (child.show >= 50) {
                            show = this.isModerator;
                        }
                        return show;
                    }));
                }
                return true;
            }
            return false;
        });
    }
    get isAdmin() {
        return store.getters['user/isAdmin'];
    }
    get isModerator() {
        return store.getters['user/isModerator'];
    }
    openDrawer(val) {
        this.isOpen = val;
    }
    emitDrawerChange(val) {
        this.$emit('change', val);
    }
};
__decorate([
    Prop({ required: true })
], Navigation.prototype, "authorized", void 0);
__decorate([
    Prop({ required: true })
], Navigation.prototype, "open", void 0);
__decorate([
    Watch('open')
], Navigation.prototype, "openDrawer", null);
__decorate([
    Watch('isOpen')
], Navigation.prototype, "emitDrawerChange", null);
Navigation = __decorate([
    Component
], Navigation);
export default Navigation;
